import { IDropdownOption } from '@fluentui/react';

export enum TokenUsageType {
  TOTAL = 'total',
  INPUT = 'input',
  OUTPUT = 'output',
}

export const tokenUsageTypeOptions: IDropdownOption[] = [
  {
    key: TokenUsageType.TOTAL,
    text: 'Total Tokens',
  },
  {
    key: TokenUsageType.INPUT,
    text: 'Input Tokens',
  },
  {
    key: TokenUsageType.OUTPUT,
    text: 'Output Tokens',
  },
];
